// Latin translations
export const la: Record<string, string> = {
  'menu.dashboard': 'Tabula',
  'menu.customers': 'Emptores',
  'menu.products': 'Producta',
  'menu.users': 'Usores',
  'menu.settings': 'Optiones',
  'menu.logout': 'Exire',
  'dashboard.title': 'Tabula',
  'dashboard.newOrder': 'Mandatum Novum',
  'order.title': 'Mandatum Novum',
  'order.customer': 'Emptor',
  'order.products': 'Producta',
  'order.total': 'Summa',
  'users.title': 'Usores',
  'users.name': 'Nomen',
  'users.email': 'Epistula',
  'common.yes': 'Ita',
  'common.no': 'Non',
  'common.cancel': 'Delere',
  'common.save': 'Servare',
  'common.search': 'Quaerere',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'Intrare',
  'login.welcome': 'Salve, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'Epistula',
  'signup.phone': 'Telephonium',
  'menu.reportsAndAccounting': 'Relationes et Rationes',
  'menu.systemAndCommunication': 'Systema et Communicatio',
};